module.exports = __webpack_public_path__ + "img/goal-five-br.5f4b04d4.png";